/**
 * A faction's key pool (several members' keys, owner's call 2026-11-02: "I'd like to use multiple members keys … those same
 * keys should share bars for their faction and start tracking"), as its members see it: numbers only, never whose keys —
 * only whether the viewer's own key is in it. Counted by the key vault (KeyVault.factionPool); shown on the website's Keys
 * page and in the Discord bot's /account status.
 */
export interface FactionPoolView {
  keys: number;
  withAccess: number;
  lent: number;
  lookups: number;
  callsPerMinute: number;
  yours: { access: boolean; lookups: boolean } | null;
}

const plural = (n: number, one: string, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;
const s3 = (n: number) => (n === 1 ? 's' : '');

/** One plain line: how many keys, what they do for the faction, whether yours is one of them. */
export function poolText(p: FactionPoolView): string {
  const parts = [
    `${plural(p.keys, 'member’s key', 'members’ keys')} share${s3(p.keys)} with your faction`,
    p.withAccess
      ? `${plural(p.withAccess, 'key')} read${s3(p.withAccess)} its data${p.lent ? ` (${p.lent} lent)` : ''} — the Discord bot can make up to ${p.callsPerMinute} calls a minute with them, taking them in turn`
      : 'none reads its data yet (that needs your faction’s “API access”)',
    p.lookups ? `${plural(p.lookups, 'key')} also answer${s3(p.lookups)} look-ups in your faction’s Discord servers` : '',
  ].filter(Boolean);
  const yours = p.yours ? `Yours is one of them${p.yours.access ? ', with your faction’s API access' : ''}.` : 'Yours isn’t (switch “Your faction” on to add it).';
  return `${parts.join('; ')}. ${yours}`;
}
